import options from './search-box.component';

export default {
    selector: 'dtSearchBox',
    options
};



// WEBPACK FOOTER //
// ./app/common/search-box/index.js